import {loadable} from 'router/routes';
import CityAPI from 'api/city';
import {initialState as searchRequestInitialState} from 'search-request/search-request-reducer';
import {createTimeWindowParams} from 'router/search';
import {parseSlug} from './utils';
import {Page} from '../router/page';

const MidFunnel = loadable(() => import('mid-funnel/MidFunnel'));

MidFunnel.getInitialState = async ({state, params}) => {
    const slug = parseSlug(params.city);
    const city = await CityAPI.get(slug).then(res => res.data);
    const pageType = Page.MID_FUNNEL;

    const {
        data: {timezone},
    } = city;

    return {
        ...state,
        city,
        searchRequest: {
            ...searchRequestInitialState,
            pageType,
            ...createTimeWindowParams(pageType, {}, timezone),
        },
    };
};

export default MidFunnel;
